import { render } from "./CodeNonParsable.vue?vue&type=template&id=1deb951e&ts=true"
import script from "./CodeNonParsable.vue?vue&type=script&lang=ts"
export * from "./CodeNonParsable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__